
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import { GetStaticPaths, GetStaticProps } from "next";

import { BlogIndex } from "@/containers/Blog/BlogIndex";
import { getBlogPage, IBlogPage } from "@/services/wordpress";

interface IProps {
  blogPage: IBlogPage;
}

const BlogArchivePage: React.FC<IProps> = ({ blogPage }) => (
  <BlogIndex blogPage={blogPage} />
);

export const getStaticPaths: GetStaticPaths = async () => {
  const { totalPages } = await getBlogPage(1);

  return {
    paths: Array.from({ length: totalPages - 1 }, (_, index) => ({
      params: { page: String(index + 2) },
    })),
    fallback: "blocking",
  };
};

 const _getStaticProps: GetStaticProps<IProps> = async ({ params }) => {
  const page = Number(params?.page);

  // Page 1 lives at /blog; reject junk like /blog/page/abc.
  if (!Number.isInteger(page) || page < 2) {
    return { notFound: true, revalidate: 3600 };
  }

  try {
    const blogPage = await getBlogPage(page);
    if (!blogPage.posts.length) {
      return { notFound: true, revalidate: 3600 };
    }

    return {
      props: { blogPage },
      revalidate: 3600,
    };
  } catch {
    // WP returns a 400 for pages beyond the last one.
    return { notFound: true, revalidate: 3600 };
  }
};

export default BlogArchivePage;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/blog/page/[page]',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  